import { OnInit, Input, ViewChild } from "@angular/core";
import * as _ from "underscore";
import { Directive, HostListener } from "@angular/core";
import { FilePreviewService } from "./file-preview.service";

@Directive({
  selector: "[filePreview]",
  standalone: true,
})
export class FilePreviewDirective implements OnInit {
  @Input() type: any;
  @Input() item: any;
  @Input() etag: any;
  @Input() file: any;
  @Input() prevent: any = true;
  @Input() resourceId: any = null;
  @Input() conversationId: any = null;

  @Input() disabledButtons: any = [];

  url: string = "";
  compRef: any;
  @ViewChild(FilePreviewDirective)
  adHost: FilePreviewDirective;

  constructor(private filePreviewService: FilePreviewService) {}

  ngOnInit(): void {}

  @HostListener("click", ["$event"])
  onClick(event) {
    if (this.prevent) {
      event.preventDefault();
      this.openPreview();
    }
  }

  private openPreview() {
    this.filePreviewService.openFile.next({
      type: this.type,
      url: this.url,
      etag: this.etag,
      file: this.file,
      resourceId: this.resourceId,
      prevent: this.prevent,
      disabledButtons: this.disabledButtons,
    });
  }
}
